import React from 'react';
import styled from 'styled-components';

const Pattern = () => {
  return (
    <StyledWrapper>
      <div className="container" />
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
  
  .container {
    width: 100%;
    height: 100%;
    min-height: 100vh;
    min-width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    --s: 120px;
    --c1: #2a2a2a;
    --c2: #333333;
    --c3: #202020;

    --_g: 0 120deg, #0000 0;
    background: conic-gradient(
        from 0deg at calc(500% / 6) calc(100% / 3),
        var(--c3) var(--_g)
      ),
      conic-gradient(
        from -120deg at calc(100% / 6) calc(100% / 3),
        var(--c2) var(--_g)
      ),
      conic-gradient(
        from 120deg at calc(100% / 3) calc(500% / 6),
        var(--c1) var(--_g)
      ),
      conic-gradient(
        from 120deg at calc(200% / 3) calc(500% / 6),
        var(--c1) var(--_g)
      ),
      conic-gradient(
        from -180deg at calc(100% / 3) 50%,
        var(--c2) 60deg,
        var(--c1) var(--_g)
      ),
      conic-gradient(
        from 60deg at calc(200% / 3) 50%,
        var(--c1) 60deg,
        var(--c3) var(--_g)
      ),
      conic-gradient(
        from -60deg at 50% calc(100% / 3),
        var(--c1) 120deg,
        var(--c2) 0 240deg,
        var(--c3) 0
      );
    background-size: calc(var(--s) * 1.732) var(--s);
    background-repeat: repeat;
    background-attachment: fixed;
    opacity: 0.7;
  }
`;

export default Pattern; 